import CategoriaService from 'src/modules/categoria/categoriaService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'CATEGORIA_VIEW';

const categoriaViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: categoriaViewActions.FIND_STARTED,
      });

      const record = await CategoriaService.find(id);

      dispatch({
        type: categoriaViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: categoriaViewActions.FIND_ERROR,
      });

      getHistory().push('/categoria');
    }
  },
};

export default categoriaViewActions;
